export default __webpack_public_path__ + "static/media/01_babie_lato.a9c76e68.png";